import List from "./CheckboxList";
import Checkbox from "./Checkbox";
import "./Checkbox.css"

const UsersLocations = () => {
  return (
    <div className="locations-container">
      
      {/* <div className="checkbox"> 
      <Checkbox /> 
      </div>

      <div className="list">
        <List />
      </div> */}
      <div></div>
    </div>
  );
};

export default UsersLocations;
